import React from 'react';
import Tooltip from '../ui/Tooltip';
import { setUpgradeModalOpen, setUpgradeReason } from '../../store/uiModalStore';
import { capRow } from '../../plans/localUsage';
import { useLocalCapRow } from './useLocalCaps';

/** Opens the upgrade with the row's sentence (a locked create never dead-ends). */
export function openUpgradeFor(row) {
  setUpgradeReason(row.text);
  setUpgradeModalOpen(true);
}

/**
 * Plans v2 card 3.3: beside a create button, once the plan's local cap for
 * `kind` is reached: a "3 / 1" chip whose tooltip reads "3 / 1 boards:
 * upgrade to Basic for unlimited" and which opens the upgrade. The create
 * button itself stays clickable and opens the same upgrade
 * (plans/localGate.js), so nothing is ever a dead button. Renders nothing on
 * a plan without that cap, or below it.
 *
 * `used` is optional: a caller that already knows the count (the list it
 * renders) passes it; otherwise the shared count (useLocalCaps) is used.
 */
export default function LocalCapHint({ kind, used, className = '', style }) {
  const shared = useLocalCapRow(kind);
  const row = used == null ? shared : capRow(kind, used, shared?.limit);
  if (!row || !row.full) return null;
  return (
    <Tooltip content={row.text} side="bottom">
      <button
        type="button"
        data-testid={`local-cap-hint-${kind}`}
        className={`local-cap-hint ${className}`.trim()}
        onClick={(e) => {
          e.stopPropagation();
          openUpgradeFor(row);
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: '1px 6px',
          borderRadius: 9999,
          fontSize: 10,
          fontWeight: 600,
          lineHeight: '16px',
          cursor: 'pointer',
          fontVariantNumeric: 'tabular-nums',
          background: 'rgba(245,158,11,0.14)',
          color: '#b45309',
          border: 'none',
          ...style,
        }}
      >
        {row.used} / {row.limit}
      </button>
    </Tooltip>
  );
}
